import SidebarCollapse from "@builder/components/app/SidebarCollapse";
import EditableInfo from "../../EditableInfo";
import ActionSelectorInput from "@builder/components/general/ActionSelectorInput";
import "./style.scss";
import { useAppSelector } from "@builder/store/store";
import { getSelectedNode } from "@builder/store/slices/BuilderSlice/builderSelectors";
import { SmartTileNode } from "@common/build/types";
import { EditableProps } from "../../editableProps";

const EditProductTile = ({ condition }: EditableProps) => {
    const cvMode = useAppSelector(state => state.builder.conditionalVariationMode);
    const selectedNode = useAppSelector(getSelectedNode) as SmartTileNode;

    if (condition && !condition(selectedNode, cvMode)) return null;

    return (
        <SidebarCollapse title="Setup">
            <div className="edit-product-tile">
                <EditableInfo
                    header="productTileInfo1"
                    body="productTileInfo2"
                    bulletPoints={{
                        points: ["productTileInfo4", "productTileInfo5", "productTileInfo6"],
                        title: "productTileInfo3"
                    }}
                />
                <div className="edit-product-tile-divider"></div>
                <ActionSelectorInput
                    actionPath={"productTileAction"}
                    actionId={selectedNode.productTileAction ? selectedNode.productTileAction[0] : undefined}
                />
            </div>
        </SidebarCollapse>
    );
};

export default EditProductTile;
